import { FC, ChangeEvent } from 'react';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { Button, Grid, Paper, NativeSelect } from '@material-ui/core';

export const PaymentDialogForm: FC = observer(() => {
  const classes = useStyles();

  const {
    upgradeLicenseStore: { paymentMethod, setPaymentMethod, setStep },
  } = useStore();

  return (
    <Grid className={classes.main} container justify='center'>
      <Paper className={classes.paper} elevation={12}>
        <p className={classes.title}>Payment dialog</p>
        <p className={classes.subTitle}>Choose payment method:</p>
        <NativeSelect
          className={classes.formControl}
          autoFocus
          value={paymentMethod}
          onChange={(event: ChangeEvent<{ value: string }>) =>
            setPaymentMethod(event.target.value as 'card' | 'ach' | 'invoice')
          }>
          <option value='card'>Pay via Credit Card</option>
          <option value='ach'>Pay using ACH</option>
          <option value='invoice'>Invoice Me</option>
        </NativeSelect>
        <Button className={classes.button} variant='contained' color='primary' onClick={() => setStep('payment-form')}>
          Next
        </Button>
      </Paper>
    </Grid>
  );
});
